import React from 'react';
import useCartStateEx from '../../../utilities/use-cart-state-ex';
import {useCartDispatch} from '../../../contexts/cart';
import {useLocation, useNavigate} from 'react-router-dom';
import searchFilter from '../../../searchFilter';

const useLocalCart = (serviceId) => {
    const localCartState = useCartStateEx(serviceId);
    const localCartStateDeferred = React.useDeferredValue(localCartState);
    const [cartVisibility, setCartVisibility] = React.useState(false);
    const setCartVisibilityCallback = React.useCallback((value) => setCartVisibility(value));
    React.useEffect(() => {
        if (!localCartState.length) {
            setCartVisibility(false);
        }
    }, [localCartState]);
    const dispatch = useCartDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const decrementEndpoint = React.useCallback((entry) => {
        if (entry.quantity > 1) {
            dispatch({type: 'decrement', payload: entry.key});
        } else {
            dispatch({type: 'remove', payload: entry.key});
        }
    });
    const incrementEndpoint = React.useCallback((entry) => {
        dispatch({type: 'increment', payload: entry.key});
    });
    const addEndpoint = React.useCallback((payload) => {
        dispatch({type: 'add', payload});
    });
    const deleteEndpoint = React.useCallback((entry) => {
        dispatch({type: 'reduceQuantity', payload: {entry: entry.key, reduceBy: entry.quantity}});
    });
    const checkout = React.useCallback(() => {
        navigate(`/checkout/ticketing/impulse${searchFilter(location.search, {impulseServiceId: serviceId})}`)
    });
    return {
        localCartState,
        localCartStateDeferred,
        isLocalCartDeferred: localCartState !== localCartStateDeferred,
        cartVisibility,
        setCartVisibility: setCartVisibilityCallback,
        decrementEndpoint,
        incrementEndpoint,
        addEndpoint,
        deleteEndpoint,
        checkout
    };
};

export default useLocalCart;